import React from 'react';
import { useTranslation } from 'react-i18next';
import { useFormState } from 'react-final-form';

import CommonField from '../common-fields/CommonField';
import { Input } from '../../../../components/common-inputs';
import CommonTextarea from '../../../../components/common-textarea/CommonTextarea';

import scss from '../ProjectRequestForm.module.scss';

function AdditionalSonarFields() {
  const { t } = useTranslation('projectRequest');

  const { submitting } = useFormState();

  return (
    <div className={scss.fieldsBlock}>
      <CommonField name='relevantUrl' label={t('relevantUrl')} isRequired>
        {({ input, meta }) => (
          <Input
            size='sm'
            value={input.value}
            onChange={input.onChange}
            onBlur={input.onBlur}
            onFocus={input.onFocus}
            placeholder={t('relevantUrlPlaceholder')}
            isError={meta.touched && meta.error}
            disabled={submitting}
          />
        )}
      </CommonField>

      <CommonField name='relevantCompetitorsUrls' label={t('relevantCompetitorsUrls')}>
        {({ input, meta }) => (
          <CommonTextarea
            value={input.value}
            onChange={input.onChange}
            onBlur={input.onBlur}
            onFocus={input.onFocus}
            placeholder={t('relevantCompetitorsUrlsPlaceholder')}
            isError={meta.touched && meta.error}
            rows='4'
            disabled={submitting}
          />
        )}
      </CommonField>
    </div>
  );
}

export default AdditionalSonarFields;
